import { useEffect, useState } from "react";
import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, IconButton, InputAdornment, MenuItem, Paper, TextField, Typography, useTheme } from "@mui/material"

import ImageProfileCircle from "../../../components/ImageProfileCircle";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MyTable from "../../../components/MyTable";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import MyTextField from "../../../components/MyTextField";
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MyDatepicker from "../../../components/my-datepicker";
import dayjs from 'dayjs';
import { getColleges, getUserInformation, getUserRightHolders, getUserTraining, setUserRightHolder, setUserTraining } from "../../../api/signalApi";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MySelect from "../../../components/MySelect";
import { updateUserData } from "../../../store/slices/auth";
import MySnackbar from "../../../components/MySnackbar";
import { UserTrainingUpdate } from "../../../interfaces/auth.interface";
import ListFilesToUpload from "../../../components/ListFilesToUpload";
import { addOrUpdateGroupId } from "../../../api/fileStorage";
import { uploadFilesToFilestorage } from "../../../utils/media-files";

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { v4 as uuidv4 } from 'uuid';
import { getDatestring } from "../../../utils/date";
import { DocumentsComponent } from "../../../components/DocumentsComponent";
import { MyPosition, MyPositionProps } from "./tapOptions-1";
import { getBankAccountsConfig } from "../../../api/signalApi";
import { BankAccountsTab } from "./BankAccountsTab";

export const RightHolders = () => {

    const theme = useTheme();
    const { companyselected, userRightHolders, connectionId } = useSelector((state: RootState) => state.auth);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dni, setDni] = useState<string>("");
    const [apellidoPaterno, setApellidoPaterno] = useState<string>("");
    const [apellidoMaterno, setApellidoMaterno] = useState<string>("");
    const [nombres, setNombres] = useState<string>("");
    const [rHDate, setRHDate] = useState<string>("");
    const [operation, setOperation] = useState<0 | 1 | 2>(0);

    const handleGetUserRightHolders = async () => {
        if (loading) return;
        setLoading(true)
        await getUserRightHolders();
        setLoading(false);
    }

    useEffect(() => {
        if (!companyselected?.Token || !connectionId || loading) {
            return;
        }
        handleGetUserRightHolders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId]);

    const resetModal = () => {
        setDni("")
        setApellidoPaterno("")
        setApellidoMaterno("")
        setNombres("")
        setRHDate("")
    }

    const modifyUserRightHolder = async () => {
        const data = {
            DNI: dni,
            ApellidoPaterno: apellidoPaterno,
            ApellidoMaterno: apellidoMaterno,
            Nombres: nombres,
            FechaNacimiento: rHDate,
            Operacion: operation,
        };
        await setUserRightHolder(data);
        handleGetUserRightHolders();
        resetModal();
    }

    return (<>
        <MyTable
            key="tab-0"
            tableHeadRows={[{
                label: "Nombres",
                rowKeyName: "Nombres",
            }, {
                label: "Apellido Paterno",
                rowKeyName: "ApellidoPaterno",
            }, {
                label: "Apellido Materno",
                rowKeyName: "ApellidoMaterno",
            }, {
                label: "DNI",
                rowKeyName: "DNI",
            }, {
                label: "Fecha de Nacimiento",
                rowKeyName: "FechaNacimiento",
                customValue: (_head: any, row: any) => {
                    return (<>{getDatestring(row.FechaNacimiento, "/", false)}</>)
                },
            }, {
                label: "",
                rowKeyName: "deleteOption",
                customValue: (_head: any, row: any) => {
                    return (
                        <IconButton
                            disabled={loading}
                            aria-label="Eliminar"
                            onClick={() => {
                                setDni(row.DNI)
                                setApellidoPaterno(row.ApellidoPaterno)
                                setApellidoMaterno(row.ApellidoMaterno)
                                setNombres(row.Nombres)
                                setRHDate(row.FechaNacimiento)
                                setOperation(2);
                                setOpenModal(true)
                            }}
                            style={{
                                minWidth: "2rem",
                                minHeight: "2rem",
                                padding: ".25rem",

                                lineHeight: "1.25rem",
                            }}
                        >
                            {loading
                                ? <CircularProgress color="primary" size="1rem" />
                                : <DeleteRoundedIcon color="error" />
                            }
                        </IconButton>
                    )
                },
            }]}
            tableRows={userRightHolders}
            hiddenItemsPerPage={true}
            customItemOptionBar={() => <Grid>
                <Button
                    variant="outlined"
                    style={{
                        backgroundColor: "white",
                        fontSize: "14px",
                    }}
                    startIcon={<AddIcon />}
                    onClick={() => {
                        setOperation(0);
                        setOpenModal(true)
                    }}
                >
                    Agregar
                </Button>
            </Grid>}
            hiddenSearchInput={true}
            loading={false}
            hiddenBottomPaginator={true}
            tableOptionsBar={{
                useDrawer: false,
            }}
            onlyTable={false}
        />

        <Dialog
            open={openModal}
            aria-labelledby="responsive-dialog-title"
            style={{ width: "100%" }}
        >
            <DialogTitle
                id="responsive-dialog-title"
                style={{ padding: "0", margin: "2rem 0 1rem 0", textAlign: "center" }}
                variant="h5"
            >
                {operation === 0
                    ? "Registro de Derecho Habientes"
                    : operation === 1
                        ? "Modificar de Derecho Habientes"
                        : "Eliminar de Derecho Habientes"
                }
            </DialogTitle>
            <DialogContent style={{ width: "100%", textAlign: "center" }}>
                <Grid container spacing="1rem">
                    <Grid item xs={12} md={6}>
                        <MyTextField
                            style={{ width: "100%" }}
                            label="Nombres"
                            onChange={({ target }) => setNombres(target.value.toUpperCase())}
                            value={nombres}
                            disabled={operation === 2}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextField
                            style={{ width: "100%" }}
                            label="Apellido Paterno"
                            onChange={({ target }) => setApellidoPaterno(target.value.toUpperCase())}
                            value={apellidoPaterno}
                            disabled={operation === 2}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextField
                            style={{ width: "100%" }}
                            label="Apellido Materno"
                            onChange={({ target }) => setApellidoMaterno(target.value.toUpperCase())}
                            value={apellidoMaterno}
                            disabled={operation === 2}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MyTextField
                            style={{ width: "100%" }}
                            label="Documento de Identidad"
                            onChange={({ target }) => setDni(target.value.toUpperCase())}
                            value={dni}
                            disabled={operation === 2}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography
                            align='left'
                            style={{
                                color: operation === 2
                                    ? theme.s10palette.S10Greygrey300
                                    : theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                            }}
                        >
                            Fecha de Nacimiento
                        </Typography>
                        <MyDatepicker
                            maxDate={dayjs()}
                            value={dayjs(rHDate)}
                            // minDate={dayjs()}
                            setSelectedDate={(value) => {
                                setRHDate(dayjs(value).toISOString());
                            }}
                            disabled={operation === 2}

                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button
                            variant="outlined"
                            style={{ width: "8rem" }}
                            startIcon={<CloseIcon style={{ height: "1rem" }} />}
                            onClick={() => {
                                resetModal();
                                setOpenModal(false)
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained"
                            color={operation === 2 ? "error" : "primary"}
                            style={{ width: "8rem" }}
                            startIcon={<CheckIcon style={{ height: "1rem" }} />}
                            disabled={operation !== 2 && (!nombres || !apellidoPaterno || !apellidoMaterno || !dni || !rHDate)}
                            onClick={() => {
                                modifyUserRightHolder();
                                setOpenModal(false);
                            }}
                        >
                            {operation === 2 ? "Emininar" : "Aceptar"}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    </>)
}

interface MsgData {
    msg: string;
    success: boolean
}

export const UserTraining = () => {

    const theme = useTheme();
    const { companyselected, userTraining, connectionId, colleges } = useSelector((state: RootState) => state.auth);
    const [openModal, setOpenModal] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [trainingType, setTrainingType] = useState<string>("01");
    const [college, setCollege] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [dateInit, setDateInit] = useState<string>("");
    const [dateEnd, setDateEnd] = useState<string>("");
    const [msgData, setMsgData] = useState<MsgData>();
    const [groupId, setGroupId] = useState<string | null>(null);
    const [operation, setOperation] = useState<0 | 1 | 2>(0);
    const [initialData, setInitialData] = useState<UserTrainingUpdate>({
        CodTipoCapacitacion: "",
        CodInstitucionEducativa: "",
        Descripcion: "",
        FechaInicio: "",
        FechaFin: "",
        Operacion: operation,
    });

    const TRAINING_TYPES = [
        {
            key: "01",
            value: "Curso",
        },
        {
            key: "02",
            value: "Diplomado",
        },
        {
            key: "03",
            value: "Maestría",
        },
        {
            key: "04",
            value: "Otros",
        },
    ]

    const resetModal = () => {
        setTrainingType("01")
        setInitialData({
            CodTipoCapacitacion: "",
            CodInstitucionEducativa: "",
            Descripcion: "",
            FechaInicio: "",
            FechaFin: "",
            Operacion: 0
        });
        setCollege("")
        setDateInit("")
        setDateEnd("")
        setDescription("")
        setSelectedFiles([]);
    }

    const hanleGetInitialInformation = async () => {
        if (loading) return;
        setLoading(true)
        await getColleges();
        await getUserTraining();
        setLoading(false);
    }

    useEffect(() => {
        if (!companyselected?.Token || !connectionId || loading) {
            return;
        }
        hanleGetInitialInformation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId]);

    const handleCloseModal = () => {
        resetModal();
        setOpenModal(false);
    }

    const trainingHasChange = (): boolean => {
        return (
            (initialData.CodTipoCapacitacion !== trainingType ||
                initialData.CodInstitucionEducativa !== college ||
                initialData.Descripcion !== description ||
                initialData.FechaInicio !== dateInit ||
                initialData.FechaFin !== dateEnd) &&
            trainingType !== "" &&
            college !== "" &&
            description !== "" &&
            dateInit !== "" &&
            dateEnd !== "" &&
            dateInit <= dateEnd
        );
    }

    const modifyUserTraining = async () => {
        if (!trainingHasChange() && operation !== 2) {
            return;
        }
        const guid = uuidv4();
        if (selectedFiles?.length) {
            const result = await uploadFilesToFilestorage(
                selectedFiles,
                console.log,
                false,
                guid
            )
            if (result === null) {
                setMsgData({
                    success: false,
                    msg: "Error subiendo el archivo al s3.",
                });
                setLoading(false);
                return;
            }
            const filestorageData = result.filestorageData
                .map(f => ({
                    ...f,
                    RUCCorporation: companyselected?.RUC as any
                }));
            const updateGroupId = await addOrUpdateGroupId(filestorageData);
            if (updateGroupId?.Type !== 0) {
                setMsgData({
                    success: false,
                    msg: "Error registrando los archivos en el s10.",
                });
                setLoading(false);
                return;
            }
        }
        const data = {
            CodTipoCapacitacion: trainingType as any,
            CodInstitucionEducativa: college,
            Descripcion: description,
            FechaInicio: dateInit,
            FechaFin: dateEnd,
            Operacion: operation,
            guid,
        }
        await setUserTraining(data);
        setMsgData({
            success: true,
            msg: "Entrenamiento registrado correctamente.",
        });
        await getUserTraining();
        resetModal();

    }

    const handleSetGroupId = (groupId: string) => {
        console.log(groupId)
        setGroupId(groupId)
    }

    return (<>
        <MyTable
            onlyTable={false}
            key="tab-0"
            tableHeadRows={[{
                label: "Tipo",
                rowKeyName: "TipoCapacitacion",
                allowOrderAction: true,
            }, {
                label: "Nombre",
                rowKeyName: "Descripcion",
                allowOrderAction: true,
            }, {
                label: "Centro de estudios",
                rowKeyName: "InstitucionEducativa",
                allowOrderAction: true,
            }, {
                label: "Fecha de inicio",
                rowKeyName: "FechaInicio",
                allowOrderAction: true,
            }, {
                label: "Fecha de fin",
                rowKeyName: "FechaFin",
                allowOrderAction: true,
            }, {
                label: "",
                rowKeyName: "deleteOption",
                customValue: (_head: any, row: any) => {
                    return (
                        <Grid container direction="row" minWidth="5rem">
                            <IconButton
                                aria-label="Eliminar"
                                onClick={() => {
                                    resetModal();
                                    setInitialData(row)
                                    setTrainingType(row.CodTipoCapacitacion)
                                    setCollege(row.CodInstitucionEducativa)
                                    setDateInit(row.FechaInicio)
                                    setDateEnd(row.FechaFin)
                                    setDescription(row.Descripcion)
                                    setOperation(2);
                                    setOpenModal(true)
                                }}
                                style={{
                                    minWidth: "2rem",
                                    minHeight: "2rem",
                                    padding: ".25rem",

                                    lineHeight: "1.25rem",
                                }}
                            >
                                <DeleteRoundedIcon color="error" />
                            </IconButton>
                            <IconButton
                                aria-label="ver adjuntos"
                                onClick={() => {
                                    handleSetGroupId(row.NroIdentificadorCapacitacion)
                                }}
                                style={{
                                    minWidth: "2rem",
                                    minHeight: "2rem",
                                    padding: ".25rem",

                                    lineHeight: "1.25rem",
                                }}
                            >
                                <AttachFileIcon color="primary" />
                            </IconButton>
                        </Grid>
                    )
                },
            }
            ]}
            tableRows={userTraining}
            hiddenItemsPerPage={true}
            hiddenSearchInput={true}
            loading={false}
            hiddenBottomPaginator={true}
            tableOptionsBar={{
                useDrawer: false,
            }}
            customItemOptionBar={() => <Grid>
                <Button
                    variant="outlined"
                    style={{
                        backgroundColor: "white",
                        fontSize: "14px",
                    }}
                    startIcon={<AddIcon />}
                    onClick={() => {
                        resetModal();
                        setOperation(0)
                        setOpenModal(true)
                    }}
                >
                    Agregar
                </Button>
            </Grid>}
        />
        <Dialog
            open={openModal}
            aria-labelledby="responsive-dialog-title"
            style={{ width: "100%" }}
        >
            <DialogTitle
                id="responsive-dialog-title"
                style={{ padding: "0", margin: "2rem 0 1rem 0", textAlign: "center" }}
                variant="h5"
            >
                {operation === 0
                    ? "Registro de capacitaciones"
                    : operation === 1
                        ? "Modificar de capacitaciones"
                        : "Eliminar de capacitaciones"
                }
            </DialogTitle>
            <DialogContent style={{ width: "100%", textAlign: "center" }}>
                <Grid container spacing="1.5rem">
                    <Grid item xs={12} style={{ textAlign: "left" }}>
                        <MySelect
                            label="Tipo de capacitación"
                            onChange={(event: { target: { value: string } }) => {
                                const value = event.target.value;
                                setTrainingType(value)
                            }}
                            value={trainingType}
                            disabled={operation === 2}
                        >
                            {TRAINING_TYPES.map((trainingType, i) => (
                                <MenuItem key={i} value={trainingType.key}>{trainingType.value}</MenuItem>
                            ))}
                        </MySelect>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "left" }}>
                        <Autocomplete
                            id="free-solo-demo"
                            size="small"
                            freeSolo
                            // sx={{
                            //     w: {xs: "60rem", md: "80rem"},
                            //     position: 'relative',
                            //     top: 0, 
                            // }}
                            onChange={(event, value) => {
                                setCollege((value as any)?.id || "")
                            }}
                            disabled={operation === 2}
                            style={{ backgroundColor: "white" }}
                            options={colleges.map((option, i) => ({
                                label: option.Descripcion,
                                id: option.CodTablaTablas,
                            }))}
                            // value={college}
                            renderInput={(params) => <TextField {...params} label="Centro de estudios" />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MyTextField
                            style={{ width: "100%" }}
                            label="Nombre de la capacitación"
                            onChange={({ target }) => setDescription(target.value.toUpperCase())}
                            value={description}
                            disabled={operation === 2}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            // variant="caption"
                            align='left'
                            style={{
                                color: operation === 2
                                    ? theme.s10palette.S10Greygrey300
                                    : theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                            }}
                        >
                            Fecha de inicio
                        </Typography>
                        <MyDatepicker
                            maxDate={dayjs()}
                            value={dayjs(dateInit)}
                            setSelectedDate={(value) => {
                                setDateInit(dayjs(value).toISOString());
                            }}
                            disabled={operation === 2}

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography
                            // variant="caption"
                            align='left'
                            style={{
                                color: operation === 2
                                    ? theme.s10palette.S10Greygrey300
                                    : theme.s10palette.S10Greygrey700,
                                fontSize: "1rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "1.25",
                            }}
                        >
                            Fecha de fin
                        </Typography>
                        <MyDatepicker
                            maxDate={dayjs()}
                            value={dayjs(dateEnd)}
                            minDate={dateInit ? dayjs(dateInit) : undefined}
                            setSelectedDate={(value) => {
                                setDateEnd(dayjs(value).toISOString());
                            }}
                            disabled={operation === 2}
                        />
                    </Grid>
                    {operation !== 2 && <Grid item xs={12}>
                        <ListFilesToUpload
                            selectedFiles={selectedFiles}
                            setSelectedFiles={setSelectedFiles}
                            buttonLabel="Agregar documento relacionado"

                        />
                    </Grid>}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button
                            variant="outlined"
                            style={{ width: "8rem" }}
                            startIcon={<CloseIcon style={{ height: "1rem" }} />}
                            onClick={handleCloseModal}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained"
                            color={operation === 2 ? "error" : "primary"}
                            style={{ width: "8rem" }}
                            startIcon={<CheckIcon style={{ height: "1rem" }} />}
                            onClick={async () => {
                                await modifyUserTraining();
                                setOpenModal(false);
                            }}
                            disabled={!trainingHasChange() && operation !== 2}
                        >
                            {operation === 2 ? "Emininar" : "Aceptar"}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
        {groupId !== null && <Dialog
            key={groupId}
            maxWidth="md"

            open={groupId !== null}
            aria-labelledby="responsive-dialog-title"
            style={{ width: "100%" }}
            PaperProps={{
                style: {
                    width: '80%',
                    // maxWidth: '600px',   // Máximo ancho del Dialog
                }
            }}
            fullWidth

        >
            <DialogTitle
                id="responsive-dialog-title"
                style={{ padding: "0", margin: "2rem 0 1rem 0", textAlign: "center" }}
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{ width: "100%", textAlign: "center" }}>
                <DocumentsComponent groupId={groupId} allowToDeleteFiles={true} allowToAddFiles={true} />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button
                            variant="outlined"
                            style={{ width: "8rem", margin: ".5rem", }}
                            startIcon={<CloseIcon style={{ height: "1rem" }} />}
                            onClick={() => setGroupId(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        {msgData?.success !== undefined && <MySnackbar
            severity={msgData?.success ? "success" : "error"}
            msg={msgData?.msg || ""}
            open={msgData?.success !== undefined}
            onClose={() => setMsgData(undefined)}
        />}
    </>)
}


const genderOptions = { M: "Masculino", F: "Femenino" };


export const MyData = ({ contractInformation }: MyPositionProps) => {

    const dispatch = useDispatch<AppDispatch>();
    const { companyselected, userData, connectionId } = useSelector((state: RootState) => state.auth);
    const { configEnabled } = useSelector((state: RootState) => state.bank);
    const [loading, setLoading] = useState(false);
    const [paternalSurname, setPaternalSurname] = useState<string>("");
    const [modalDetailOption, setModalDetailOption] = useState<string | null>(null);
    const [maternalSurname, setMaternalSurname] = useState<string>("");
    const [names, setNames] = useState<string>("");
    const [gender, setGender] = useState<"F" | "M">("F");
    const [address, setAddress] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [waithingUpdateResponde, setWaithingUpdateResponde] = useState<boolean>(false);
    const [informationUpdated, setInformationUpdated] = useState<boolean>(false);

    useEffect(() => {
        if (!companyselected?.Token || !connectionId || loading) {
            return;
        }
        const handleGetUserInformation = async () => {
            if (loading) return;
            setLoading(true)
            await getUserInformation();
            setLoading(false);
        }
        handleGetUserInformation();
        getBankAccountsConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])

    useEffect(() => {
        if (userData) {
            handleResetForm();
        }
        if (waithingUpdateResponde) {
            setInformationUpdated(true);
            setWaithingUpdateResponde(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData])

    const userDataHasChange = (): boolean => {
        return (
            userData !== null &&
            (
                userData.ApellidoPaterno !== paternalSurname ||
                userData.ApellidoMaterno !== maternalSurname ||
                userData.Nombres !== names ||
                userData.Sexo !== gender ||
                userData.Direccion !== address ||
                userData.TelefonoMovil !== phone
            )
        )
    }

    const handleResetForm = () => {
        setPaternalSurname(userData?.ApellidoPaterno || "");
        setMaternalSurname(userData?.ApellidoMaterno || "");
        setNames(userData?.Nombres || "");
        setGender(userData?.Sexo || "F");
        setAddress(userData?.Direccion || "");
        setPhone(userData?.TelefonoMovil || "");
    }

    const handleUpdateInformation = () => {
        if (!userData || !userDataHasChange()) return;
        dispatch(updateUserData({
            ApellidoPaterno: paternalSurname,
            ApellidoMaterno: maternalSurname,
            Nombres: names,
            Sexo: gender,
            Direccion: address,
            TelefonoMovil: phone,
        }));
        setWaithingUpdateResponde(true)
    }

    const formatPhoneNumber = (phoneNumberInput: string) => {
        const formattedInput = phoneNumberInput.replace(/\D/g, '').substring(0, 9);
        let formattedNumber = '';
        for (let i = 0; i < formattedInput.length; i++) {
            if (i % 3 === 0 && i !== 0) {
                formattedNumber += '-';
            }
            formattedNumber += formattedInput[i];
        }
        return formattedNumber;
    };

    return (
        <Grid container spacing={"1rem"}>
            <Grid container direction="row" item xs={12} sm={6} md={4} width="100%">
                <Paper
                    elevation={3}
                    style={{
                        width: "100%",
                        borderRadius: "0.5rem",
                        padding: "1.5rem",
                    }}
                >
                    <Grid
                        container
                        item
                        justifyContent="center"
                    >
                        {companyselected?.RUC && userData?.CodIdentificador && <ImageProfileCircle
                            width="5.5rem"
                            height="5.5rem"
                            ruc={companyselected?.RUC as any}
                            userId={userData?.CodIdentificador as any}
                            userName={`${userData?.ApellidoPaterno} ${userData?.ApellidoMaterno} ${userData?.Nombres}`}
                            uploadOption={true}
                        />}
                    </Grid>
                    <Divider
                        style={{
                            width: "100%",
                            backgroundColor: "#E8E8E8",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                        }}
                    />
                    <Grid item style={{ marginTop: ".5rem", marginBottom: "1.5rem" }}>
                        <Typography variant="h6" style={{ fontSize: "1rem" }}>
                            Información personal
                        </Typography>
                    </Grid>
                    <Grid container direction={"row"} item xs={12} width="100%" rowSpacing="1rem" >
                        <Grid item xs={12}>
                            <MyTextField
                                label="Código"
                                value={userData?.CodIdentificador || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Correo corporativo"
                                value={userData?.EMail || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Nombres"
                                value={names}
                                onChange={({ target }) => setNames(target.value.toUpperCase())}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Apellido Paterno"
                                value={paternalSurname}
                                onChange={({ target }) => setPaternalSurname(target.value.toUpperCase())}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Apellido Materno"
                                value={maternalSurname}
                                onChange={({ target }) => setMaternalSurname(target.value.toUpperCase())}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} container direction="column" justifyContent="flex-end">
                            <MySelect
                                label="Sexo"
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setGender(value as any)
                                }}
                                value={gender || "F"}
                            >
                                <MenuItem value="F">{genderOptions["F"]}</MenuItem>
                                <MenuItem value="M">{genderOptions["M"]}</MenuItem>
                            </MySelect>
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Nacionalidad"
                                value={userData?.Nacionalidad || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Lugar de nacimiento"
                                value={userData?.LugarNacimiento || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Fecha de Nacimiento"
                                value={userData?.Aniversario
                                    ? getDatestring(userData?.Aniversario, '-', false)?.split("T")[0]
                                    : ""
                                }
                                style={{ width: "100%" }}
                                disabled
                                placeholder="Buscar..."
                                InputProps={{
                                    endAdornment: <InputAdornment position="end" >
                                        <CalendarTodayIcon />
                                    </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Tipo de documento Identidad"
                                value={userData?.TipoDocumento || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="N° de doc. de identidad"
                                value={userData?.DNI || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Estado civil"
                                value={userData?.EstadoCivil || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="N° de licencia de conducir"
                                value={userData?.NumeroLicenciaConducir || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                value="top"
                                control={<Checkbox checked={userData?.Activo || false} disabled />}
                                label="Activo"
                                labelPlacement="top"
                                defaultChecked
                            />
                        </Grid>

                        <Grid container item direction="row" xs={12} justifyContent="space-between" >
                            <Grid item sx={{ mr: { xs: "0", md: "1.5rem" } }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CloseIcon style={{ height: "1rem" }} />}
                                    onClick={handleResetForm}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    variant="contained"
                                    startIcon={<CheckIcon style={{ height: "1rem" }} />}
                                    onClick={handleUpdateInformation}
                                    disabled={!userDataHasChange()}
                                >
                                    Actualizar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid container direction="row" item xs={12} sm={6} md={4} width="100%">
                <Paper
                    elevation={3}
                    style={{
                        width: "100%",
                        borderRadius: "0.5rem",
                        padding: "1.5rem",
                    }}
                >
                    <Grid item style={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
                        <Typography variant="h6" style={{ fontSize: "1rem" }}>
                            Información de contacto
                        </Typography>
                    </Grid>
                    <Grid container direction={"row"} item xs={12} width="100%" rowSpacing="1rem" >
                        <Grid item xs={12}>
                            <MyTextField
                                label="Distrito residencia actual"
                                value={userData?.LugarDireccion || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Dirección de residencial actual"
                                value={address}
                                onChange={({ target }) => setAddress(target.value.toUpperCase())}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Teléfono de casa"
                                value={userData?.TelefonoFijo || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Celular"
                                value={phone}
                                onChange={({ target }) => setPhone(formatPhoneNumber(target.value))}
                                style={{ width: "100%" }}
                                className="phone-input"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Correo personal"
                                value={userData?.EMailPersonal || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Contacto de emergencia"
                                value={userData?.AvisarEmergenciaNombre || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Teléfono de emergencia"
                                value={userData?.AvisarEmergenciaTelefono || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>


                        <Grid container item direction="row" xs={12} justifyContent="space-between" >
                            <Grid item sx={{ mr: { xs: "0", md: "1.5rem" } }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<CloseIcon style={{ height: "1rem" }} />}
                                    onClick={handleResetForm}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    variant="contained"
                                    startIcon={<CheckIcon style={{ height: "1rem" }} />}
                                    onClick={handleUpdateInformation}
                                    disabled={!userDataHasChange()}
                                >
                                    Actualizar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item style={{ marginTop: "1rem", }}>
                        <Typography variant="h6" style={{ fontSize: "1rem" }}>
                            Mi Cargo
                        </Typography>
                    </Grid>
                    <MyPosition
                        contractInformation={contractInformation}
                    />
                </Paper>
            </Grid>
            <Grid container direction="row" item xs={12} sm={6} md={4} width="100%">
                <Paper
                    elevation={3}
                    style={{
                        width: "100%",
                        borderRadius: "0.5rem",
                        padding: "1.5rem",
                    }}
                >
                    <Grid item style={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
                        <Typography variant="h6" style={{ fontSize: "1rem" }}>
                            Información de familiar
                        </Typography>
                    </Grid>
                    <Grid container direction={"row"} item xs={12} width="100%" rowSpacing="1rem" >
                        <Grid item xs={12}>
                            <MyTextField
                                label="Nombre de cónyuge o conviviente"
                                value={userData?.NombreConyugue || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} width="100%" marginTop="1.5rem" >
                        <Divider orientation="horizontal" flexItem />
                    </Grid>
                    <Grid item style={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
                        <Typography variant="h6" style={{ fontSize: "1rem" }}>
                            Información educativa
                        </Typography>
                    </Grid>
                    <Grid container direction={"row"} item xs={12} width="100%" rowSpacing="1rem" >
                        <Grid item xs={12}>
                            <MyTextField
                                label="Situación educativa"
                                value={userData?.SituacionEducativa || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Institución educativa"
                                value={userData?.InstitucionEducativa || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="Carrera profesional"
                                value={userData?.Carrera || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                value="top"
                                control={<Checkbox checked={userData?.Colegiado === true} disabled />}
                                label="¿Colegiado?"
                                labelPlacement="top"
                                defaultChecked
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextField
                                label="N° de colegiatura"
                                value={userData?.NumeroColegiatura || ""}
                                style={{ width: "100%" }}
                                disabled
                            />
                        </Grid>
                    </Grid>

                    <Grid container direction="row" marginTop="2rem">
                        {["Derecho Habientes", "Capacitación", "Documentos", ...(configEnabled ? ["Cuentas Bancarias"] : [])].map(option => (
                            <Grid key={option} container item xs={12} mb=".7rem" justifyContent={"flex-start"}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    style={{ lineHeight: "normal" }}
                                    startIcon={<RemoveRedEyeOutlinedIcon style={{ height: "1rem", lineHeight: "normal" }} />}
                                    onClick={() => setModalDetailOption(option)}
                                >
                                    {option}
                                </Button>
                            </Grid>
                        ))}

                    </Grid>
                </Paper>
            </Grid >

            <Dialog
                open={modalDetailOption !== null}
                aria-labelledby="responsive-dialog-title"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle
                    id="responsive-dialog-title"
                    style={{ padding: "0", margin: "2rem 0 0.5rem 0", textAlign: "center" }}
                    variant="h5"
                >
                    {modalDetailOption}
                </DialogTitle>
                <DialogContent style={{ width: "100%", textAlign: "center" }}>
                    {
                        modalDetailOption === "Derecho Habientes"
                            ? <RightHolders />
                            : modalDetailOption === "Capacitación"
                                ? <UserTraining />
                                : modalDetailOption === "Documentos"
                                    ? <DocumentsComponent allowToDeleteFiles={true} allowToAddFiles={true} />
                                    : <BankAccountsTab />
                    }
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={12} textAlign={"right"}>
                            <Button
                                variant="outlined"
                                style={{ width: "8rem", margin: ".5rem", }}
                                startIcon={<CloseIcon style={{ height: "1rem" }} />}
                                onClick={() => setModalDetailOption(null)}
                            >
                                Cerrar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <MySnackbar
                severity="success"
                msg={"Información actualizada"}
                open={informationUpdated}
                onClose={() => setInformationUpdated(false)}
            />

        </Grid >
    )
}